import * as React from 'react';

import BaseOrgLocationListLayout from './BaseOrgLocationListLayout';
import LocationEditPopup from '../containers/locations/LocationEditPopup';


export default ({ locationId }) => {
  return BaseOrgLocationListLayout(
    <LocationEditPopup locationId={locationId} />
  );
};
